import React from 'react';
import { useIntl } from 'react-intl';

import { Button, FieldRow, FormFooter, InputCopy, Title } from '@xsolla/ui-core';
import { ChevronRight, SuccessColorful } from '@xsolla/ui-icons';
import { Modal } from '@xsolla/ui-modal';

import { PROJECT_LINKS } from '../../../constants';
import { Separator } from '../../ui';
import { InputTitle, LinkButton, SubHeader, SuccessModalWrapper } from './style';

type Props = {
  OAuthMainData: {
    id: number;
    secret: string;
  };
  onClose: () => void;
};

export const SuccessConnectModal = ({ onClose, OAuthMainData }: Props): JSX.Element => {
  const intl = useIntl();
  const { OAUTH2 } = PROJECT_LINKS;
  return (
    <Modal>
      <SuccessModalWrapper>
        <SuccessColorful size={40} />
        <Title center indent="sm" data-test-id="oauth2-connect-success-title">
          {intl.messages['authorization.settings.oauth2.modal.connect.success.title']}
        </Title>
        <p>{intl.messages['authorization.settings.oauth2.modal.connect.success.subtitle']}</p>
      </SuccessModalWrapper>
      <div style={{ marginBottom: '12px' }}>
        <InputTitle>
          {intl.messages['authorization.settings.oauth2.modal.connect.success.client-id']}
        </InputTitle>
        <InputCopy
          id="oauth_id"
          defaultValue={OAuthMainData.id}
          successfulLabel="Copied"
          uiSize="md"
          data-test-id="oauth2-connect-modal-id"
        />
      </div>
      <div>
        <InputTitle>
          {intl.messages['authorization.settings.oauth2.server.secret-key.title']}
        </InputTitle>
        <InputCopy
          type="password"
          defaultValue={OAuthMainData.secret}
          successfulLabel="Copied"
          uiSize="md"
          data-test-id="oauth2-connect-modal-secret"
        />
      </div>
      <Separator margin="32px 0" />
      <SubHeader>
        {intl.messages['authorization.settings.oauth2.modal.connect.success.more-title.title']}
      </SubHeader>
      <LinkButton>
        <a href={OAUTH2} target="_blank" rel="noreferrer" data-test-id="oauth2-connect-modal-doc">
          {intl.messages['authorization.settings.oauth2.modal.connect.success.more-title']}
        </a>
        <a href={OAUTH2} target="_blank" rel="noreferrer">
          <ChevronRight />
        </a>
      </LinkButton>
      <FormFooter>
        <FieldRow justify="center" stretched>
          <Button
            look="tertiary"
            palette="muted"
            onClick={onClose}
            data-test-id="oauth2-connect-modal-close">
            {intl.messages['authorization.settings.oauth2.modal.connect.success.dismiss']}
          </Button>
        </FieldRow>
      </FormFooter>
    </Modal>
  );
};
